import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CompanyForm = _resolveComponent("CompanyForm")!
  const _component_OfferForm = _resolveComponent("OfferForm")!
  const _component_AccountingForm = _resolveComponent("AccountingForm")!
  const _component_ResumePage = _resolveComponent("ResumePage")!
  const _component_EndRegisterPage = _resolveComponent("EndRegisterPage")!
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    dense: "",
    class: "display-flex justify-center align-center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: "form",
        cols: "12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step_,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step_) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserForm, {
                    user: _ctx.data_.user,
                    "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data_.user) = $event)),
                    style: {"min-width":"49vw"},
                    onUserFormValidation: _ctx.userFormValidation
                  }, null, 8, ["user", "onUserFormValidation"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CompanyForm, {
                    onCompanyFormValidation: _ctx.companyFormValidation,
                    style: {"min-width":"49vw"},
                    data: _ctx.data_.company,
                    "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data_.company) = $event))
                  }, null, 8, ["onCompanyFormValidation", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_OfferForm, {
                    offer: _ctx.data_.offer,
                    "onUpdate:offer": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data_.offer) = $event)),
                    style: {"min-width":"49vw"}
                  }, null, 8, ["offer"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_AccountingForm, {
                    data: _ctx.data_.accounting,
                    "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data_.accounting) = $event)),
                    declaration: _ctx.data.declaration,
                    offer: _ctx.data.offer,
                    style: {"max-height":"50vh","overflow-y":"auto","overflow-x":"hidden"}
                  }, null, 8, ["data", "declaration", "offer"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ResumePage, {
                    modelValue: _ctx.data_,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data_) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_EndRegisterPage)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_DeclarationForm, {
                    modelValue: _ctx.data_.declaration,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data_.declaration) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}